import { uploadThemeMedia } from "../../functions/uploadThemeMedia";
import { renameFileForUpload } from "./safeUploadFileName";

const IMAGE_QUIZ_MAX_MB = 5;
const IMAGE_QUIZ_EXT = ["jpg", "jpeg", "png"];
const IMAGE_QUIZ_MIME = ["image/jpeg", "image/jpg", "image/png"];

export const IMAGE_QUIZ_REQUIRED_WIDTH = 810;
export const IMAGE_QUIZ_REQUIRED_HEIGHT = 113;
export const IMAGE_QUIZ_DIMENSION_LABEL = `${IMAGE_QUIZ_REQUIRED_WIDTH}×${IMAGE_QUIZ_REQUIRED_HEIGHT}px`;

export const IMAGE_QUIZ_FIELD = "image_quiz_image";

export { renameFileForUpload };

function getImageDimensions(file) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({
        width: img.naturalWidth || img.width,
        height: img.naturalHeight || img.height,
      });
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Could not read image file."));
    };
    img.src = url;
  });
}

export async function validateImageQuizImageFile(file) {
  if (!file) return { ok: false, message: "Please choose an image file." };

  const ext = (file.name.split(".").pop() || "").toLowerCase();
  if (!IMAGE_QUIZ_EXT.includes(ext)) {
    return {
      ok: false,
      message: `Unsupported format for ${file.name}. Only PNG or JPG images are allowed.`,
    };
  }

  const mime = (file.type || "").toLowerCase();
  if (mime && !IMAGE_QUIZ_MIME.includes(mime)) {
    return {
      ok: false,
      message: `Unsupported format for ${file.name}. Only PNG or JPG images are allowed.`,
    };
  }

  if (file.size > IMAGE_QUIZ_MAX_MB * 1024 * 1024) {
    return {
      ok: false,
      message: `${file.name} exceeds ${IMAGE_QUIZ_MAX_MB}MB.`,
    };
  }

  try {
    const { width, height } = await getImageDimensions(file);
    if (width !== IMAGE_QUIZ_REQUIRED_WIDTH || height !== IMAGE_QUIZ_REQUIRED_HEIGHT) {
      return {
        ok: false,
        message: `Image must be exactly ${IMAGE_QUIZ_DIMENSION_LABEL}. Your image is ${width}×${height}px.`,
      };
    }
  } catch {
    return {
      ok: false,
      message: "Failed to validate image dimensions. Please choose a valid PNG or JPG file.",
    };
  }

  return { ok: true };
}

export async function uploadImageQuizImageFile({ file, adminToken, currentTheme }) {
  const check = await validateImageQuizImageFile(file);
  if (!check.ok) throw new Error(check.message);

  const renamed = renameFileForUpload(file, "image");
  const formData = new FormData();
  formData.append("themeName", currentTheme);
  formData.append("uploadOnly", "true");
  formData.append(IMAGE_QUIZ_FIELD, renamed);

  const data = await uploadThemeMedia({ formData, token: adminToken });
  const filename = data?.uploaded_files?.[IMAGE_QUIZ_FIELD];
  if (!filename) {
    throw new Error("Image upload failed — no filename returned from server.");
  }
  return filename;
}
